// extracted by mini-css-extract-plugin
module.exports = {"columnHeader":"footer_columnHeader__I1vRI","link":"footer_link__jorUI","mobileAccordion":"footer_mobileAccordion__H6Co4"};